import styled from 'styled-components';
import { logger } from '../../utils/logger';
const SkeletonLoader = ({ itemsCount = 7 }) => {
  const totalItems = Array.from({ length: itemsCount }, (_, index) => index);
  logger.log('totalItems', totalItems);
  return (
    <SkeletonWrapper>
      {totalItems.map((item) => (
        <div key={item} className="skeleton-section">
          <div className="skeleton-title"></div>
          <div className="skeleton-content">
            <div className="skeleton-line"></div>
            <div className="skeleton-line short"></div>
          </div>
        </div>
      ))}
    </SkeletonWrapper>
  );
};
const SkeletonWrapper = styled.div`
  .skeleton-section {
    margin-bottom: 2rem;
    padding: 1.5rem;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    background: #fff;

    .skeleton-title {
      height: 20px;
      width: 200px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: loading 1.5s infinite;
      border-radius: 4px;
      margin-bottom: 1rem;
    }

    .skeleton-content {
      .skeleton-line {
        height: 16px;
        background: linear-gradient(
          90deg,
          #f0f0f0 25%,
          #e0e0e0 50%,
          #f0f0f0 75%
        );
        background-size: 200% 100%;
        animation: loading 1.5s infinite;
        border-radius: 4px;
        margin-bottom: 0.8rem;

        &.short {
          width: 60%;
        }
      }
    }
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
export default SkeletonLoader;
